import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {PayType} from 'com/gongxigames/math/core/game/enums/PayType';
import {Pay} from 'com/gongxigames/math/core/game/Pay';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {WinPresentationEvents} from '@gongxigames/framework/slot/modules/winpresentation';
import { BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';
import {PickBonusEvents} from '@gongxigames/framework/slot/modules/pick';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {KeypadInfoElementsView} from '@gongxigames/framework/slot/modules/keypadInfo/KeypadInfoElementsView';
import {KeypadInfoElementsModule} from '@gongxigames/framework/slot/modules/keypadInfo/KeypadInfoElementsModule';
import {KeypadInfoElementsViewMobile} from '@gongxigames/framework/slot/modules/keypadInfo/KeypadInfoElementsViewMobile';
import {KeypadControlsEvents} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsEvents';

// @ts-ignore
// TODO: refactor required
export class KeypadInfoMainGameState extends ModuleState<KeypadInfoElementsView | KeypadInfoElementsViewMobile, KeypadInfoElementsModule> {
    public onLeaveState(): void {
    }

    public onEnterState(): void {
        this.view.initializeMainGameLayout();
    }

    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.RESPIN_ON_FREESPINS_RESTORED, this.onFreeSpinsRestored.bind(this));
        this.setEventHandler('General.Game.INITIALIZED', this.onGameInitialized.bind(this));
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(ReelsEvents.ALL_REELS_STOPPED, this.onAllReelsStopped.bind(this));
        this.setEventHandler(WinPresentationEvents.INITIAL_ANIMATION_STARTED, this.onInitialAnimation.bind(this));
        this.setEventHandler(WinPresentationEvents.PAY_ANIMATION_STARTED, this.onPayAnimation.bind(this));
        this.setEventHandler('General.WinPresentation.WIN_METER_FINISHED', this.onWinMeterFinished.bind(this));
        this.setEventHandler(
            WinPresentationEvents.PAY_ANIMATIONS_AND_WIN_METER_FINISHED,
            this.onWinMeterAndPayAnimationsFinished.bind(this)
        );
        this.setEventHandler(BigWinEvents.STARTED, this.onBigWinStarted.bind(this));
        this.setEventHandler(BigWinEvents.FINISHED, this.onBigWinFinished.bind(this));
        this.setEventHandler(BigWinEvents.WIN_METER_FINISHED, this.onBigWinMeterFinished.bind(this));
        this.setEventHandler(BigWinEvents.POST_FEATURE_BW_SKIPPED, this.onBigWinSkipped.bind(this));
        this.setEventHandler(FlowModuleEvents.NO_WIN, this.onNoWinSpin.bind(this));
        this.setEventHandler(FlowModuleEvents.FREESPINS_RESTORED, this.onFreeSpinsRestored.bind(this));
        this.setEventHandler(FlowModuleEvents.RESTORE_PICK_BONUS, this.onRestorePickBonus.bind(this));
        this.setEventHandler(PickBonusEvents.STARTED, this.onPickBonusStarted.bind(this));
        this.setEventHandler(PickBonusEvents.FINISHED, this.onPickBonusFinished.bind(this));
        this.setEventHandler(KeypadControlsEvents.TOTAL_BET_CHANGED, this.onTotalBetChanged.bind(this));
        this.setEventHandler(GenericPopupEvents.INTRO_STARTED, this.onPopupStarted.bind(this));
        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
        this.setEventHandler(GenericPopupEvents.FADE_OUT_STARTED, this.onPopupFadeOut.bind(this));
        this.setEventHandler('Autoplay.STOPPED', this.onAutoplayStopped.bind(this));
    }

    protected onPopupStarted(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_INTRO) {
            this.onFreeSpinIntroStarted();
        }

        if (type === GenericPopupType.FREESPIN_OUTRO) {
            this.onFreeSpinsOutroStarted();
        }

        if (type === GenericPopupType.FREESPIN_RETRIGGER) {
            this.onFreeSpinsRetriggerStarted();
        }
    }

    protected onPopupClosed(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_INTRO) {
            this.onFreeSpinsStarted();
        }

        if (type === GenericPopupType.FREESPIN_OUTRO) {
            this.onFreeSpinsEnded();
        }

        if (type === GenericPopupType.FREESPIN_RETRIGGER) {
            this.onFreeSpinsRetriggerFinished();
        }

        if (type === GenericPopupType.RESPIN_OUTRO) {
            this.onRespinFinished();
        }
    }

    protected onPopupFadeOut(_type: symbol): void {
    }

    protected onFreeSpinIntroStarted(): void {
        this.module.isFreeGames = true;
        this.clearTicker();
        this.view.refreshFreeSpinsInfo(this.module.logic.getFreeGamesTotalCount() -
            this.module.logic.getFreeGamesCount() + 1, this.module.logic.getFreeGamesTotalCount());

        this.module.gotoState(KeypadInfoElementsModule.FREESPIN_STATE);
    }

    protected onBigWinStarted(): void {
        this.module.isBigWin = true;

        if (!this.module.isBonusWin) {
            this.view.refreshLeftTicker('');
        }

        this.view.refreshRightTicker('');
    }

    protected onBigWinFinished(): void {
        this.module.isBigWin = false;

        if (this.module.isBigWinAfterFreeGames) {
            this.module.isBigWinAfterFreeGames = false;
        }

        if (this.module.isBigWinAfterBonusGame) {
            this.module.isBigWinAfterBonusGame = false;

            this.isBonusWithoutRoundWin() && this.setRightTickerValue(true);
        }

        this.onGamePays();
    }

    protected onBigWinSkipped(): void {
        this.isBigWinAfterFeature() && this.setRightTickerValue(true);
    }

    protected isBigWinAfterFeature(): boolean {
        const isFeatureEnded: boolean = this.module.logic.previousAction !== this.module.logic.nextAction &&
            this.module.logic.nextAction === Action.SPIN;
        const isFreeSpins = this.module.logic.spinData.action === Action.FREESPIN;

        if (isFreeSpins) {
            return this.module.isBigWinAfterFreeGames;
        }

        return isFeatureEnded;
    }

    protected onTotalBetChanged(): void {
        this.view.refreshLeftTicker('');

        this.setRightTickerValue();
    }

    protected onGameInitialized(): void {
        this.module.refreshBalance();
        this.setIdleTickerText();
    }

    protected onPickBonusStarted(): void {
        this.clearTicker();
    }

    protected onPickBonusFinished(wonValue: number): void {
        if (wonValue) {
            const str = this.module.languageService.get('bonusWin',
                {win: this.module.currencyFormatter.formatCents(wonValue)});

            this.view.refreshLeftTicker(str);
            this.module.isBonusWin = true;
        }

        this.validateToRefreshBalance();

        this.module.isBonusWin = false;

        if (!this.module.logic.getTotalWin() && this.module.logic.spinData.action === Action.SPIN) {
            this.setRightTickerValue(true);
        } else if (this.isBigWinAfterBonus() && this.module.logic.spinData.action === Action.SPIN) {
            this.module.isBigWinAfterBonusGame = true;
        }
    }

    protected isBigWinAfterBonus(): boolean {
        return this.module.logic.getTotalWin() >= this.module.logic.getBigWinLimit();
    }

    protected isBonusWithoutRoundWin(): boolean {
        return this.module.logic.previousSpinRoundWin === 0;
    }

    protected onReelsSpinningStarted(): void {
        if (this.module.logic.nextAction === Action.SPIN) {
            this.module.browser.addTimeout(() => this.module.refreshBalance(), 0);
        }

        if (this.module.logic.nextAction === Action.SPIN && this.module.isFreeGames) {
            this.module.isFreeGames = false;
        }

        this.view.refreshFreeSpinsInfo(this.module.logic.getFreeGamesTotalCount() -
            this.module.logic.getFreeGamesCount() + 1, this.module.logic.getFreeGamesTotalCount());
        this.setSpinTickerText();
    }

    protected onAllReelsStopped(): void {
        this.setIdleTickerText(this.module.logic.getWin() <= 0 && !this.module.isFreeGamesEnd);
    }

    protected onAutoplayStopped(): void {
        this.setIdleTickerText(true);
    }

    protected onWinMeterFinished(): void {
        if (!this.module.isBigWin) {
            this.validateToRefreshBalance();
        }
    }

    protected onWinMeterAndPayAnimationsFinished(): void {
        this.setRightTickerValue(true);
    }

    protected onFreeSpinsStarted(): void {
        this.view.initializeFreeSpinsLayout();
    }

    protected onRestorePickBonus(): void {
        this.clearTicker();
        this.module.isBonusWin = true;
    }

    protected onFreeSpinsRestored(): void {
        this.module.isFreeGames = true;
        this.module.gotoState(KeypadInfoElementsModule.FREESPIN_STATE);
        this.view.initializeFreeSpinsLayout();
        this.refreshFreeSpinsInfo();
    }

    protected refreshFreeSpinsInfo(): void {
        const freeSpinsLeft = this.isLastFreeSpin() ? this.module.logic.getRestoredFreeGamesTotalCount() :
            this.module.logic.getFreeGamesTotalCount() - this.module.logic.getFreeGamesCount();
        const freeSpinsTotal = this.isLastFreeSpin() ? this.module.logic.getRestoredFreeGamesTotalCount() :
            this.module.logic.getFreeGamesTotalCount();

        this.view.refreshFreeSpinsInfo(freeSpinsLeft, freeSpinsTotal);
    }

    protected onFreeSpinsOutroStarted(): void {
        this.module.isFreeGamesEnd = true;
        this.clearTicker();
    }

    protected onFreeSpinsEnded(): void {
        this.module.isFreeGamesEnd = false;
        this.view.initializeMainGameLayout();
        this.view.refreshBalance(this.module.logic.getBalance());

        if (!this.isBigWinFromAllFreeSpins()) {
            this.setRightTickerValue(true);
        } else {
            this.module.isBigWinAfterFreeGames = true;
        }
    }

    protected isBigWinFromAllFreeSpins(): boolean {
        return this.module.logic.isBigTotalWin();
    }

    protected onGamePays(): void {
        if (!this.module.isBigWin) {
            const win = (this.module.isFreeGames || this.module.logic.previousAction === Action.PICK) ?
                this.module.logic.getTotalWin() : this.module.logic.getWin();
            const key = this.module.isFreeGames ? 'freeGameBonusWin' : 'gamePay';
            const str = this.module.languageService.get(key, {win: this.module.currencyFormatter.formatCents(win)});

            this.view.refreshLeftTicker(str);
        } else {
            if (this.module.isBigWin && this.module.isFreeGames) {
                this.module.isBigWinAfterFreeGames = true;
            }
        }
    }

    protected onInitialAnimation(): void {
        this.onGamePays();
    }

    protected onFreeSpinsFinishedInitialAnimation(): void {
        const str = this.module.languageService.get('freeGameBonusWin',
            {win: this.module.currencyFormatter.formatCents(this.module.getFreeGamesWin())});

        this.view.refreshLeftTicker(str);
    }

    protected onPayAnimation(pay: Pay): void {
        if (this.module.isFreeGames && pay.type === PayType.SCATTER) {
            this.onFreeSpinsFinishedInitialAnimation();
        } else {
            if (pay.type === PayType.LINE) {
                this.setLineWinTickerText(`${pay.lineId + 1}`, pay.win * pay.bet);
            } else if (pay.type === PayType.SCATTER) {
                this.onScatterPay(pay);
            } else {
                if (pay.ways > 0) {
                    this.setWaysWinTickerText(pay.ways, pay.win * pay.bet);
                }
            }
        }
    }

    protected onScatterPay(pay: Pay): void {
        if (pay.win === 0) {
            return;
        }

        const str = this.module.languageService.get('scatterPay',
            {win: this.module.currencyFormatter.formatCents(pay.win * pay.bet)});

        this.view.refreshLeftTicker(str);
    }

    protected setLineWinTickerText(lineNr: string, win: number): void {
        const str = this.module.languageService.get('linePay',
            {lineNr, win: this.module.currencyFormatter.formatCents(win)});

        this.view.refreshLeftTicker(str);
    }

    protected setWaysWinTickerText(waysNr: number, win: number): void {
        const str = this.module.languageService.get(waysNr > 1 ? 'winPays' : 'winPay',
            {waysNr, win: this.module.currencyFormatter.formatCents(win)});

        this.view.refreshLeftTicker(str);
    }

    protected onBigWinMeterFinished(): void {
        this.validateToRefreshBalance();
    }

    protected onNoWinSpin(): void {
        this.validateToRefreshBalance();
    }

    protected setIdleTickerText(isIdle = true): void {
        this.setRightTickerValue(isIdle);

        if (isIdle) {
            this.view.refreshLeftTicker('');
        }
    }

    protected setRightTickerValue(isIdle = true): void {
        if (!this.module.logic.canSpin(this.module.logic.getTotalBet())) {
            this.view.refreshRightTicker(this.module.languageService.get('lowBalance'));
        } else {
            if (this.module.settings.get('autoplayMode') || this.module.logic.nextAction !== Action.SPIN) {
                this.view.refreshRightTicker(this.module.languageService.get('goodLuck'));
            } else {
                this.view.refreshRightTicker(isIdle ? this.module.languageService.get('pressSpin') : '');
            }
        }
    }

    protected clearTicker(): void {
        this.view.refreshLeftTicker('');
        this.view.refreshRightTicker('');
    }

    protected setSpinTickerText(): void {
        this.view.refreshLeftTicker(this.module.languageService.get('playing'));
        this.view.refreshRightTicker(this.module.languageService.get('goodLuck'));
    }

    protected onFreeSpinsRetriggerStarted(): void {
        this.module.isRetriggerFreeGames = true;
        this.view.refreshFreeSpinsInfo(this.module.logic.getFreeGamesTotalCount() - this.module.logic.getFreeGamesCount(),
            this.module.logic.getFreeGamesTotalCount());

        this.clearTicker();
    }

    protected onFreeSpinsRetriggerFinished(): void {
        this.module.isRetriggerFreeGames = false;
    }

    protected onRespinFinished(): void {
        if (!this.module.logic.isLastFreeSpin()) {
            this.module.refreshBalance();
        }
    }

    protected isLastFreeSpin(): boolean {
        return this.module.logic.getFreeGamesCount() === 0;
    }

    protected validateToRefreshBalance(): void {
        const isRespin = this.module.logic.previousAction === Action.RESPIN;

        if (!this.module.logic.isLastFreeSpin() && !isRespin) {
            this.module.refreshBalance();
        }
    }
}
